import { IEnglishLevel } from '../../../../api/apiSlice.types';

export const getFullLevelString = (level: IEnglishLevel) =>
  `${level.title.id.replaceAll('_', '').toUpperCase()} - ${level.title.name}`;
